module.exports = __webpack_public_path__ + "img/finance_income.3bedbc70.svg";